import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Header from "../Header/Header";
import { Button, Form, FormGroup, Label, Input } from "reactstrap";
import { AuthContext } from "../../contexts/AuthContext";
import Footer from "../Footer/Footer";
import "./Login.css";
// import logo from "./Logo.png";

import Swal from "sweetalert2";
import { jwtDecode as decode } from 'jwt-decode'

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { loginUser, user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [text, setText] = useState(false);

   function handleClick() {
    navigate("/Inicio");
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    const jsonSend = {
      email,
      password,
    };
    const LOGIN_URL = import.meta.env.VITE_URL_LOGIN;
    try {
      const res = await axios.post(LOGIN_URL, jsonSend);
      loginUser(res.data.token);
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Bienvenido",
        showConfirmButton: false,
        timer: 2000,
      });
      handleClick();
    } catch (error) {
      // Obtener mensaje de error de forma segura
      let errorMessage = "Error de conexión";
      if (error.response?.data) {
        if (typeof error.response.data === "string") {
          errorMessage = error.response.data;
        } else if (error.response.data.message) {
          errorMessage = error.response.data.message;
        } else if (error.response.data.error) {
          errorMessage = error.response.data.error;
        } else {
          errorMessage = JSON.stringify(error.response.data);
        }
      } else if (error.message) {
        errorMessage = error.message;
      }

      Swal.fire({
        icon: "error",
        title: "Error al iniciar sesión",
        text: errorMessage,
      });
      console.error("Error de login:", error);
    }
  };

  document.body.classList.add("white-content")

  return (
    <>
      {/* <Header /> */}
      <div className="container col-sm-5">
        <div className="card login">
          <img
            src="/Logo-Sistemify-Login.png"
            height="10%"
            width="100%"
            alt="auto"
          />
          <div className="body">
            <Form className="container" onSubmit={handleSubmit}>
              <div className="row">
                <FormGroup className="col-sm-6">
                  <Label>Email</Label>
                  <Input
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    type="email"
                    placeholder="type your email"
                  />
                </FormGroup>
                <FormGroup className="col-sm-6">
                  <Label>Password</Label>
                  <Input
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    type="password"
                    placeholder="type your password here"
                  />
                </FormGroup>
              </div>
              <Button id="botonlogin" color="success">
                Login
              </Button>
            </Form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
